import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddPriceRequest } from '../models/request/price/AddPriceRequest';
import { GetPriceListPagingAndFilterRequest } from '../models/request/price/GetPriceListPagingAndFilterRequest';

export class PriceService {
    static async getPriceList(_isCustomActive: boolean, _isOpenArea: boolean | undefined, _isClosedArea: boolean | undefined, _isHeatControllerRoom: boolean | undefined, _heatControlDetailId: string | undefined) {
        try {
            var inputObj = {
                isCustomActive: _isCustomActive,
                isOpenArea: _isOpenArea,
                isClosedArea: _isClosedArea,
                isHeatControllerRoom: _isHeatControllerRoom,
                heatControlDetailId: _heatControlDetailId
            };

            console.log('SERVICE CALL - getPriceList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Price/getPriceList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportPriceList(inputObj: GetPriceListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportPriceList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Price/exportPriceList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getPriceListPagingAndFilter(inputObj: GetPriceListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetPriceListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Price/GetPriceListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addPrice(inputObj: AddPriceRequest) {
        try {
            console.log('SERVICE CALL - AddPrice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Price/AddPrice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deletePrice(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deletePrice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Price/deletePrice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getPriceById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getPriceById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Price/getPriceById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}